// import { useMemo } from 'react'
// import { Interface } from '@ethersproject/abi'
import { AddressZero } from '@ethersproject/constants'
import dateFormat from 'dateformat'
import { useHostContract } from '../hooks/useContract'

// import ERC20_ABI from '../constants/abis/erc20.json'
import { useSingleCallResult } from '../state/multicall/hooks'

export function HostList(page: number, owner?: string): any {
  const contract = useHostContract(false)
  const listRes = useSingleCallResult(contract, 'getUserRecords', [owner, page, 3]).result

  const list = listRes?.recordArr || []
  const total = Number(listRes?.total.toString()) || 0
  
  let recordList = list.map((item) => {
    return {
      id: item.id.toString(),
      bnbFee: Number(item.bnbFee.toString() / 10**18).toFixed(5),
      buyMemeAmount: Number(item.buyMemeAmount.toString() / 10**18).toFixed(4),
      buyUsdtAmount: Number(item.buyUsdtAmount.toString() / 10**18).toFixed(4),
      loss: Number(item.loss.toString() / 10**18).toFixed(4),
      reward: Number(item.reward.toString() / 10**18).toFixed(4),
      sellMemeAmount: Number(item.sellMemeAmount.toString() / 10**18).toFixed(4),
      sellUsdtAmount: Number(item.sellUsdtAmount.toString() / 10**18).toFixed(4),
      time: dateFormat(item.time.toString() * 1000, 'yyyy-mm-dd HH:MM'),
      user: item.user,
      rewardIsGet: item.rewardIsGet
    }
  })
  recordList = recordList.filter((item) => {
    return item.user !== AddressZero
  })
  return {
    recordList,
    totalPage: Math.ceil(total / 3)
  }
}

export default HostList
